import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useState } from 'react';

function SetBoundsFeature({ data = null }) {
    const map = useMap();
    const [counter, setCounter] = useState(0);
    useEffect(() => {
        if (!data || !map || counter > 0) return;
        const isLine = Array.isArray(
            data?.features[0]?.geometry?.coordinates[0],
        );
        const position = isLine
            ? [
                  data?.features[0]?.geometry?.coordinates[0][1],
                  data?.features[0]?.geometry?.coordinates[0][0],
              ]
            : [
                  data?.features[0]?.geometry?.coordinates[1],
                  data?.features[0]?.geometry?.coordinates[0],
              ];
        if (!position[0]) return;
        if (!!position && data?.features?.length > 0) {
            map.flyTo(position);
            map.setView(position);
            if (isLine) map.flyToBounds(L.geoJson(data).getBounds());
        }
        setCounter(counter + 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, map]);
    return null;
}

export default SetBoundsFeature;
